import { useSelector } from 'react-redux';
import { isSmallerSelector, isBiggerSelector, isBiggerThanLargeSelector } from '../components/layout/mediaquery.js';

/**
 * @template {Boolean} small - Viewport size is small
 * @template {Boolean} large - Viewport size is large
 * @template {Boolean} extraLarge - Viewport size is extra large
 * @return {{small:small, large:large, extraLarge:extraLarge}} layout
 */
export default function useLayoutSize() {
	const small = useSelector(isSmallerSelector);
	const large = useSelector(isBiggerSelector);
	const extraLarge = useSelector(isBiggerThanLargeSelector);

	return { small, large, extraLarge };
}
